// An integer number of grosze gives an exact price, with no rounding.
export function formatGroszeAsZlotyLatex(grosze) {
  if(!Number.isSafeInteger(grosze))throw new TypeError("Kwota musi być całkowitą liczbą groszy.");
  const amount=Math.abs(grosze);
  return `${grosze<0?"-":""}${Math.floor(amount/100)}{,}${String(amount%100).padStart(2,"0")}`;
}
